<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1AQz6zm/tc-custom/9781647502621.jpg?1719603367462" alt="This image is the cover for the book You, Naughty Mum!"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">You, Naughty Mum!
      </h1>
      <p class="bookDescription body article font2">
        <p>A truly varied and innovative collection, branded Lucio Angelini. Next to apparently traditional fairy tales, in which the author had fun practicing the so-called “reversal of the reader's expectations” (<em>You, Naughty Mum!</em>, for example, very enjoyable even by an adult audience), we find ironic reinterpretations of famous fairy tales (<em>Whitedwarf and the Seven Snows</em>) or fairy tales in which the real and the surreal intertwine in a particularly liberating mix (in <em>Inside Oronzo’s </em><em>B</em><em>ig </em><em>H</em><em>ead,</em> the child Oronzo takes revenge in a totally unpredictable way for the pedagogical sadism of his teacher). Particularly interesting are some “meta-tales”, in which the author does not hesitate to highlight typical “ingredients” or “clichés” or “construction mechanisms” of traditional fairy tales.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lucio Angelini
      </h2>
      
      <p class="authorDescription body article"><p style='margin-top:0cm;margin-right:0cm;margin-bottom:.0001pt;margin-left:0cm;font-size:14px;font-family:"Calibri",sans-serif;text-align:justify;'><br></p><p style='margin-top:0cm;margin-right:0cm;margin-bottom:.0001pt;margin-left:0cm;font-size:14px;font-family:"Calibri",sans-serif;text-align:justify;'><span style='font-family:"Times New Roman",serif;'>As he wrote in one of his Italian novels (<em>Il fantasma di Andersen</em>): &ldquo;The most striking episode of my childhood was when the ghost of a tall, slouching boy with a big nose appeared to me: Hans Christian Andersen.&rdquo; Born in Fano, Italy, but living in Venice, Lucio Angelini is a translator of novels and essays for major Italian publishers (Einaudi, Mondadori, Frassinelli, Fazi, and others) and a writer. He translated into Italian Charlotte Bront&euml;, Virginia Woolf, Edgar Allan Poe, Gandhi, Einstein, Tobias Wolff, Lewis Carroll and others, including Patricia Cornwell&rsquo;s <em>Body of Evidence</em> (<em>Oggetti di reato</em>, Mondadori). He also translated into Italian three novels by Hans Christian Andersen: <em>Only a Fiddler, O.T. &ndash; A Danish Novel, The Two Baronesses</em>. As a writer, he has written mainly short stories for children and young adults. His collection <em>You, Naughty Mum! (And Other Tales)(Quella bruttacattiva della mamma!, </em>Emme Edizioni<em>)</em> was translated into French with the title <em>M&eacute;chante Maman</em> (Flammarion). In 2013, he published in Italy <em>The Chinese Gondolier (Il gondoliere cinese)</em>, an environmentalist noir for adults, in support of the campaign for the expulsion of giant cruise ships from the Venetian lagoon.</span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?42e89160